import { APPS_QUICK_NAV_PAGES } from "constants/quickNav/apps";
import { QuickNavPage } from "constants/quickNav/types";

export const SETTINGS_QUICK_NAV_PAGES: QuickNavPage[] = [
  { name: "Products & Services", path: "/settings/services" },
  { name: "Cart", path: "/settings/billing/cart" },
  { name: "Billing", path: "/settings/billing" },
  { name: "Billing Invoices", path: "/settings/billing/invoices" },
  { name: "Payment Methods", path: "/settings/billing/paymentmethod" },
  { name: "Billing Address", path: "/settings/billing/billinginfo" },
  { name: "Profile", path: "/settings/profile" },
  { name: "Connect to Claude", path: "/settings/claude-integration" },
  { name: "Team", path: "/settings/team" },
  { name: "Audit log", path: "/settings/auditlog" },
  { name: "API access", path: "/settings/api-settings" },
  { name: "Support tickets", path: "/settings/tickets" },
];

export const SETTINGS_APP_QUICK_NAV_PAGES: QuickNavPage[] = [
  ...SETTINGS_QUICK_NAV_PAGES,
  ...APPS_QUICK_NAV_PAGES,
];
